<div class="p-4 sm:p-6 flex flex-col gap-2 min-w-0">
  <app-card>
    <span title class="dark:text-dark-text">{{ 'connectionpoint.history.title' | translate }}</span>
    <div class="flex flex-col gap-4" [attr.aria-busy]="historyState() === 'loading'">
      @if (historyState() === 'loading') {
        <p role="status" class="py-4 text-secondary dark:text-dark-text">{{ 'common.loading' | translate }}</p>
      } @else if (historyState() === 'error') {
        <div role="alert" class="flex items-center justify-between gap-4 py-4 dark:text-dark-text">
          <span>{{ 'common.error.fetch' | translate }}</span>
          <button type="button" class="px-3 py-2 rounded-md bg-gray-100 dark:bg-dark-hover" (click)="fetchHistory()">
            {{ 'table.refresh' | translate }}
          </button>
        </div>
      }
      <div class="overflow-x-auto" [hidden]="historyState() !== 'ready'">
        <app-table
          class="block min-w-[48rem]"
          [config]="connectionpointHistoryTableConfig"
          [data]="tableData"
          [(selectedElements)]="selectedElements">
        </app-table>
      </div>

      @if (selectedElements.length > 0) {
        <div class="table-wrapper relative shadow-sm overflow-x-auto">
          <div class="border border-gray-200 dark:border-dark-border rounded-md overflow-hidden">
            <table class="w-full rounded-md table-fixed border-collapse overflow-hidden bg-white dark:bg-dark-card border border-gray-200 dark:border-dark-border"
              [style.min-width.px]="256 + selectedElements.length * 160">
              <tbody>
                @for (col of dataColumns; track col.title) {
                  <tr class="border-b border-gray-200 dark:border-dark-border odd:bg-gray-50 dark:odd:bg-dark-hover">
                    <th class="w-64 text-left px-2 py-2 font-normal border-r border-gray-200 dark:border-dark-border dark:text-dark-text">{{ col.title | translate }}
                    </th>
                    @for (element of selectedElements; track element; let j = $index) {
                      <td class="text-primary dark:text-dark-text py-2 px-2 border-slate-200 truncate">
                        <app-table-cell
                          [config]="col"
                          [data]="element"
                        ></app-table-cell>
                      </td>
                    }
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </div>
      }
    </div>
  </app-card>

  @if (connectionPointState() === 'loading') {
    <p role="status" class="px-5 text-secondary dark:text-dark-text">{{ 'common.loading' | translate }}</p>
  } @else if (connectionPointState() === 'error') {
    <div role="alert" class="flex items-center justify-between gap-4 px-5 dark:text-dark-text">
      <span>{{ 'common.error.fetch' | translate }}</span>
      <button type="button" class="px-3 py-2 rounded-md bg-gray-100 dark:bg-dark-hover" (click)="fetchConnectionPoint()">
        {{ 'table.refresh' | translate }}
      </button>
    </div>
  } @else if (connectionPoint?.connectionPointOwnsConnectionRights) {
    <app-card>
      <span title class="dark:text-dark-text">{{ 'connectionRight.historyTitle' | translate }}</span>
      <div [attr.aria-busy]="rightsState() === 'loading'">
        @if (rightsState() === 'loading') {
          <p role="status" class="py-4 text-secondary dark:text-dark-text">{{ 'common.loading' | translate }}</p>
        } @else if (rightsState() === 'error') {
          <div role="alert" class="flex items-center justify-between gap-4 py-4 dark:text-dark-text">
            <span>{{ 'common.error.fetch' | translate }}</span>
            <button type="button" class="px-3 py-2 rounded-md bg-gray-100 dark:bg-dark-hover" (click)="fetchConnectionRights()">
              {{ 'table.refresh' | translate }}
            </button>
          </div>
        }
        <div class="overflow-x-auto" [hidden]="rightsState() !== 'ready'">
          <app-table
            class="block min-w-[64rem]"
            [config]="connectionRightHistoryTableConfig"
            [data]="connectionRights">
          </app-table>
        </div>
      </div>
    </app-card>
  }
</div>
